export default {
    "public-text": "Extranet de Clientes",
    "navigation": {
        "home": "Inicio",
        "invoices": "Facturas",
        "delivery-notes": "Albaranes",
        "stocks": "Existencias",
        "services": "Servicios",
        "technical-sheets": "Fichas Técnicas",
        "packing-lists": "Packing Lists",
        "admin-home": "Inicio",
        "clients": "Clientes",
        "users": "Usuarios",
        "audit": "Auditoría",
        "executions": "Ejecuciones de datos",
        "documentation": "Documentación",
        "transportation": "Transportes"
    }
};